// extracted by mini-css-extract-plugin
export var calendarView = "_pr-0";